<base-section [index]="index" [section]="section" *ngIf="sectionRendered.periods.length>0 && sectionRendered.active">
  <div class="evenement-sit-section-container">
    <div class="grid grid-section flex items-start" *ngIf="sectionRendered.introduction || sectionRendered.title">
      <div class="content flex-1">
        <h2 class="h2" [innerHTML]="sectionRendered.title"></h2>
        <div class="introduction" [innerHTML]="sectionRendered.introduction"></div>
      </div>
    </div>
    <div class="grid grid-section grid-cols-1 mt-3 overflow-auto gap-l" [ngClass]="{'md-grid-cols-3':periodsActiveCount>1}">
      <ng-container *ngFor="let period of sectionRendered.periods">
        <div class="events-container col-span-1" *ngIf="period.active">
          <h3 class="h5" [innerHTML]="period.subtitle"></h3>
          <synapi-list-items (onTotalChange)="onPeriodTotal(period,$event)"
                             [standalone]="true"
                             [pagecountMax]="5"
                             [col]="1"
                             [scrollHorizontal]="periodsActiveCount==1"
                             [size]="3"
                             [datemin]="period.from"
                             [datemax]="period.to"
                             [scids]="[period.selection_sit,'evenements']"
                             [ngClass]="{'list-without-map':true}"
          ></synapi-list-items>
        </div>
      </ng-container>

    </div>
  </div>
</base-section>
